import { render, staticRenderFns } from "./CarouselCreate.vue?vue&type=template&id=594a33fc&"
import script from "./CarouselCreate.vue?vue&type=script&lang=js&"
export * from "./CarouselCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('594a33fc')) {
      api.createRecord('594a33fc', component.options)
    } else {
      api.reload('594a33fc', component.options)
    }
    module.hot.accept("./CarouselCreate.vue?vue&type=template&id=594a33fc&", function () {
      api.rerender('594a33fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/carousel/CarouselCreate.vue"
export default component.exports